module.exports = __webpack_public_path__ + "static/media/high-school-vr-coding.8948c389.webp";